import React from 'react';
import { header, skills, resumeSections } from '../data/resume';

import ResumeSection from './ResumeSection';

const Resume = () => {
    return (
        <section id='resume'>
            <div className='resume-header'>
                <h1>{header.name}</h1>
                <p className='subhead'>{`${header.email} | ${header.phone} | ${header.location}`}</p>
                <p>
                    <a rel='noopener noreferrer' target='_blank' href={`${header.githubURL}`}>Github</a>
                    &nbsp;|&nbsp;
                    <a rel='noopener noreferrer' target='_blank' href={`${header.linkedInURL}`}>LinkedIn</a>
                </p>
            </div>
            <div id='resume-skills' className='res-section'>
                <h3>Skills</h3>
                <div>
                    {
                        skills.map(skill => <span key={skill} className='skill'><span className='bar'>|</span>{skill}</span>)
                    }
                    <span className='bar'>|</span>
                </div>
            </div>
            <div className='resume-sections'>
                {resumeSections.map(section => {
                    return <ResumeSection key={section.title} section={section}/>
                })}
            </div>
        </section>
    )
}

export default Resume;